import WhiteNavbar from "components/Navbars/WhiteNavbar";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Input,
  InputGroup,
  Alert,
  Spinner,
  Card,
  CardBody,
  Badge,
} from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";
import Footer from "components/Footers/Footer";
import {
  FaInfoCircle,
  FaGavel, // Kusur oranı için ikon
  FaTrash,
  FaPrint,
  FaExclamationTriangle,
} from "react-icons/fa";

// Trafik Ceza Maddeleri Listesi (Formdan alındı)
const trafficCodes = [
  { value: "k", label: "İhlal Maddesi Yok" },
  { value: "t", label: "20/1-a/1" },
  { value: "t", label: "20/1-d" },
  { value: "t", label: "20/1-d-8" },
  { value: "t", label: "21/1" },
  { value: "t", label: "21/5" },
  { value: "t", label: "23/2-a" },
  { value: "t", label: "23/2-b" },
  { value: "t", label: "23/3-a-1" },
  { value: "t", label: "23/3-a-2" },
  { value: "t", label: "23/3-b-1" },
  { value: "t", label: "23/3-b-2" },
  { value: "t", label: "23/3-c-1" },
  { value: "t", label: "23/3-c-2" },
  { value: "t", label: "23/4" },
  { value: "t", label: "23/5-a" },
  { value: "t", label: "23/5-b" },
  { value: "t", label: "25. Madde" },
  { value: "t", label: "26/1" },
  { value: "t", label: "26/2" },
  { value: "t", label: "26/3" },
  { value: "t", label: "30/1-a" },
  { value: "t", label: "30/1-b" },
  { value: "t", label: "31/1-a" },
  { value: "t", label: "31/1-b" },
  { value: "t", label: "32/1" },
  { value: "t", label: "32/3" },
  { value: "t", label: "34/a" },
  { value: "t", label: "34/b" },
  { value: "t", label: "34/c" },
  { value: "t", label: "36/3-a" },
  { value: "t", label: "36/3-b" },
  { value: "t", label: "36/3-c" },
  { value: "t", label: "39/2" },
  { value: "t", label: "39/3" },
  { value: "t", label: "39/4" },
  { value: "t", label: "42/11" },
  { value: "t", label: "44/1-a" },
  { value: "t", label: "44/1-b" },
  { value: "a", label: "46/2-a" },
  { value: "a", label: "46/2-b" },
  { value: "a", label: "46/2-c" },
  { value: "a", label: "46/2-d" },
  { value: "a", label: "46/2-e" },
  { value: "a", label: "46/2-f" },
  { value: "a", label: "46/2-g" },
  { value: "a", label: "46/2-h" },
  { value: "t", label: "46/3" },
  { value: "a", label: "47/1-a" },
  { value: "a", label: "47/1-b" },
  { value: "a", label: "47/1-c" },
  { value: "t", label: "47/1-d" },
  { value: "t", label: "48/5" },
  { value: "t", label: "48/8" },
  { value: "t", label: "48/9" },
  { value: "t", label: "49/3" },
  { value: "t", label: "51/2-a" },
  { value: "t", label: "51/2-b" },
  { value: "t", label: "51/2-c" },
  { value: "t", label: "52/1-a" },
  { value: "t", label: "52/1-b" },
  { value: "t", label: "52/1-c" },
  { value: "t", label: "52/1-d" },
  { value: "a", label: "53/1-a" },
  { value: "a", label: "53/1-b" },
  { value: "a", label: "53/1-c" },
  { value: "a", label: "53/1-d" },
  { value: "a", label: "53/2" },
  { value: "a", label: "54/1-a" },
  { value: "a", label: "54/1-b" },
  { value: "t", label: "55. Madde" },
  { value: "a", label: "56/1-a" },
  { value: "a", label: "56/1-b" },
  { value: "a", label: "56/1-c" },
  { value: "a", label: "56/1-d" },
  { value: "a", label: "56/1-e" },
  { value: "a", label: "57/1-a" },
  { value: "a", label: "57/1-b" },
  { value: "a", label: "57/1-c" },
  { value: "a", label: "57/1-d" },
  { value: "a", label: "57/1-e" },
  { value: "a", label: "57/1-f" },
  { value: "t", label: "58. Madde" },
  { value: "a", label: "59. Madde" },
  { value: "t", label: "60/1-a" },
  { value: "t", label: "60/1-b" },
  { value: "t", label: "60/1-c" },
  { value: "t", label: "60/1-d" },
  { value: "t", label: "60/1-e" },
  { value: "t", label: "60/1-f" },
  { value: "t", label: "60/1-g" },
  { value: "t", label: "60/1-h" },
  { value: "t", label: "61/1-a" },
  { value: "t", label: "61/1-b" },
  { value: "t", label: "61/1-c" },
  { value: "t", label: "61/1-d" },
  { value: "t", label: "61/1-e" },
  { value: "t", label: "61/1-f" },
  { value: "t", label: "61/1-g" },
  { value: "t", label: "61/1-h" },
  { value: "t", label: "61/1-ı" },
  { value: "t", label: "61/1-j" },
  { value: "t", label: "61/1-k" },
  { value: "t", label: "61/1-l" },
  { value: "t", label: "61/1-m" },
  { value: "t", label: "61/1-n" },
  { value: "t", label: "61/1-o" },
  { value: "t", label: "63. madde" },
  { value: "t", label: "64/1-a-1" },
  { value: "t", label: "64/1-a-2" },
  { value: "t", label: "64/1-a-3" },
  { value: "t", label: "64/1-b-1" },
  { value: "t", label: "64/1-b-2" },
  { value: "t", label: "64/1-b-3" },
  { value: "t", label: "64/1-b-4" },
  { value: "t", label: "64/1-b-5" },
  { value: "t", label: "64/1-b-6" },
  { value: "t", label: "65/1-a" },
  { value: "t", label: "65/1-b-(a)" },
  { value: "t", label: "65/1-b-(b)" },
  { value: "t", label: "65/1-b-(c)" },
  { value: "t", label: "65/1-b-(d)" },
  { value: "t", label: "65/1-b-(e)" },
  { value: "t", label: "65/1-c" },
  { value: "t", label: "65/1-d" },
  { value: "t", label: "65/1-e" },
  { value: "t", label: "65/1-f" },
  { value: "t", label: "65/1-g" },
  { value: "t", label: "65/1-h" },
  { value: "t", label: "65/1-i" },
  { value: "t", label: "65/1-j" },
  { value: "t", label: "65/1-k" },
  { value: "t", label: "65/4" },
  { value: "t", label: "65/a" },
  { value: "t", label: "66. Madde" },
  { value: "a", label: "67/1-a" },
  { value: "a", label: "67/1-b" },
  { value: "a", label: "67/1-c" },
  { value: "a", label: "67/1-d" },
  { value: "a", label: "68/1-a-1" },
  { value: "a", label: "68/1-a-2" },
  { value: "a", label: "68/1-a-3" },
  { value: "a", label: "68/1-b-1" },
  { value: "a", label: "68/1-b-2" },
  { value: "a", label: "68/1-c" },
  { value: "t", label: "69/1" },
  { value: "t", label: "70. Madde" },
  { value: "t", label: "71. Madde" },
  { value: "t", label: "72. Madde" },
  { value: "t", label: "73/a" },
  { value: "t", label: "73/b" },
  { value: "t", label: "73/c" },
  { value: "a", label: "74/a" },
  { value: "a", label: "74/b" },
  { value: "t", label: "75. Madde" },
  { value: "t", label: "76. Madde" },
  { value: "t", label: "77/1-b" },
  { value: "t", label: "77/1-c" },
  { value: "t", label: "78/1-a" },
  { value: "t", label: "78/1-b" },
  { value: "t", label: "81/1-a" },
  { value: "t", label: "81/1-b" },
  { value: "t", label: "81/1-c" },
  { value: "t", label: "81/1-d" },
  { value: "t", label: "81/1-e" },
  { value: "t", label: "81/3" },
  { value: "t", label: "82/1-a" },
  { value: "t", label: "82/1-b" },
  { value: "t", label: "82/1-c" },
  { value: "a", label: "84/a" },
  { value: "a", label: "84/b" },
  { value: "a", label: "84/c" },
  { value: "a", label: "84/d" },
  { value: "a", label: "84/e" },
  { value: "a", label: "84/f" },
  { value: "a", label: "84/g" },
  { value: "a", label: "84/h" },
  { value: "a", label: "84/i" },
  { value: "a", label: "84/j" },
  { value: "a", label: "84/k" },
  { value: "a", label: "84/l" },
  { value: "a", label: "109/b-8 KTY" },
];

const KusurOraniHesaplama = () => {
  // State
  const [formData, setFormData] = useState({
    biz: "",
    karsi: "",
  });
  const [uiSonuc, setUiSonuc] = useState("");
  const [lastSonuc, setLastSonuc] = useState(null);
  const [loading, setLoading] = useState(false);

  // User & time
  const currentUser = "ARS Hukuk";
  const [currentDate, setCurrentDate] = useState(
    new Date().toLocaleString("tr-TR")
  );

  useEffect(() => {
    AOS.init();
    const t = setInterval(
      () => setCurrentDate(new Date().toLocaleString("tr-TR")),
      1000
    );
    return () => clearInterval(t);
  }, []);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleClearForm = () => {
    setFormData({ biz: "", karsi: "" });
    setUiSonuc("");
    setLastSonuc(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUiSonuc("");
    setLoading(true);

    // 1. ADIM: Seçilen metinlerin (label) karşılığı olan harf değerlerini (value) buluyoruz.
    const secilenBiz = trafficCodes.find((item) => item.label === formData.biz);
    const secilenKarsi = trafficCodes.find((item) => item.label === formData.karsi);

    const params = new URLSearchParams();
    // API harf kodlarını (t, a, k) bekliyor
    params.append("biz", secilenBiz ? secilenBiz.value : "");
    params.append("karsi", secilenKarsi ? secilenKarsi.value : "");
    params.append("Hesapla", "Hesapla");

    try {
      // Cloudflare Worker Adresiniz (Sonuna target parametresi ekliyoruz)
      const myWorkerUrl = "https://deger-kaybi-proxy.ibrahimoncelerwork.workers.dev/";
      const targetSite = "https://ahmetmerkepci.com/kusur-orani-hesaplama-nasil-yapilir/";
      const finalUrl = `${myWorkerUrl}?target=${encodeURIComponent(targetSite)}`;

      const response = await fetch(finalUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params,
      });

      const html = await response.text();

      // ---------------------------------------------------------
      // HTML AYRIŞTIRMA (GÖNDERDİĞİNİZ HTML'E GÖRE GÜNCELLENDİ)
      // ---------------------------------------------------------
      
      // 1. Sizin İhlal Durumunuzu Yakala: <strong>...</strong> ihlal durumunuz: <strong>(BURASI)</strong>
      const bizDurumMatch = html.match(/Sizin\s*<\/strong>\s*ihlal durumunuz:\s*<strong>(.*?)<\/strong>/i);
      
      // 2. Sizin Kusur Oranınızı Yakala: <strong><h3>(%50)<h3></strong>
      const bizOranMatch = html.match(/Sizin\s*<\/strong>\s*kusur oranınız:\s*<strong>\s*<h3>(.*?)<h3>/i);

      // 3. Karşı İhlal Durumunu Yakala
      const karsiDurumMatch = html.match(/Karşı sürücünün\s*<\/strong>\s*ihlal durumu:\s*<strong>(.*?)<\/strong>/i);
      
      // 4. Karşı Kusur Oranını Yakala
      const karsiOranMatch = html.match(/Karşı sürücünün\s*<\/strong>\s*kusur oranı:\s*<strong>\s*<h3>(.*?)<h3>/i);


      if (bizDurumMatch && bizOranMatch) {
        const bizDurum = bizDurumMatch[1]; // Örn: Tali Kusur
        const bizOran = bizOranMatch[1];   // Örn: %50
        const karsiDurum = karsiDurumMatch ? karsiDurumMatch[1] : "-";
        const karsiOran = karsiOranMatch ? karsiOranMatch[1] : "-";

        const sonucObj = {
          bizDurum,
          bizOran,
          karsiDurum,
          karsiOran,
          tarih: currentDate,
          kullanici: currentUser,
        };

        setLastSonuc(sonucObj);

        setUiSonuc(
          <div className="result-container">
            <div style={{ padding: "24px 24px 16px", textAlign: "center" }}>
              <h4 style={{ fontSize: "1.4rem", fontWeight: 700, color: "#123274", marginBottom: "16px", fontFamily: "Benguiat Regular" }}>
                KUSUR ORANI SONUCU
              </h4>
              <Badge color="light" pill className="position-absolute top-0 end-0 mt-3 me-3" style={{ fontSize: "0.75rem" }}>
                {currentUser} | {currentDate}
              </Badge>
            </div>

            <div style={{ backgroundColor: "#f8f9fa", padding: "24px", borderRadius: "0 0 12px 12px" }}>
              <Row className="g-3">
                {/* SİZİN SONUÇLAR */}
                <Col md={6}>
                  <div className="bg-white p-4 rounded shadow-sm text-center h-100 border">
                    <h5 className="text-muted text-uppercase mb-3" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>SİZİN DURUMUNUZ</h5>
                    <div style={{ fontSize: "2.5rem", fontWeight: 800, color: "#dc3545" }}>{bizOran}</div>
                    <div style={{ fontSize: "1.2rem", fontWeight: 500, color: "#344767" }}>{bizDurum}</div>
                  </div>
                </Col>

                {/* KARŞI TARAF SONUÇLAR */}
                <Col md={6}>
                  <div className="bg-white p-4 rounded shadow-sm text-center h-100 border">
                    <h5 className="text-muted text-uppercase mb-3" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>KARŞI TARAF</h5>
                    <div style={{ fontSize: "2.5rem", fontWeight: 800, color: "#dc3545" }}>{karsiOran}</div>
                    <div style={{ fontSize: "1.2rem", fontWeight: 500, color: "#344767" }}>{karsiDurum}</div>
                  </div>
                </Col>
              </Row>
            </div>

            <div style={{ display: "flex", justifyContent: "center", gap: "16px", padding: "24px", borderTop: "1px solid #e9ecef", flexWrap: "wrap" }}>
              <Button color="secondary" onClick={printResult} size="lg" className="shadow-sm" style={{ padding: "12px 24px", fontWeight: 600, borderRadius: "8px" }}>
                <FaPrint className="me-2" /> YAZDIR
              </Button>
            </div>
          </div>
        );
      } else {
        setUiSonuc(
          <Alert color="warning" style={{ borderRadius: 8, marginBottom: 0 }}>
            Sonuç hesaplanamadı. Lütfen seçtiğiniz maddeleri kontrol ediniz veya daha sonra tekrar deneyiniz.
          </Alert>
        );
      }
    } catch (error) {
      console.error("Hata detayı:", error);
      setUiSonuc(
        <Alert color="danger" style={{ borderRadius: 8, marginBottom: 0 }}>
          <h5 className="alert-heading mb-1">Bağlantı Hatası</h5>
          <p className="mb-0">Sunucuya bağlanırken bir sorun oluştu. Lütfen internet bağlantınızı kontrol edin.</p>
        </Alert>
      );
    }

    setLoading(false);

    setTimeout(() => {
      const el = document.getElementById("sonuc-container");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
  };

  const printResult = () => {
    const kayit = lastSonuc;
    if (!kayit) return;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Kusur Oranı Raporu</title>
          <style>
            body { font-family: 'Segoe UI', Arial, sans-serif; margin: 40px; line-height: 1.6; color: #344767; }
            .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #123274; padding-bottom: 20px; color: #123274; }
            .logo { margin-bottom: 15px; display: flex; justify-content: center; }
            .logo-circle { width: 60px; height: 60px; border-radius: 50%; background: #123274; color: white; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 24px; }
            .result-grid { display: flex; justify-content: space-between; gap: 20px; margin-top: 30px; }
            .result-box { flex: 1; border: 1px solid #ddd; border-radius: 8px; padding: 20px; text-align: center; background: #f8f9fa; }
            .rate { font-size: 40px; font-weight: bold; color: #dc3545; margin: 10px 0; }
            .status { font-size: 18px; font-weight: 600; color: #344767; }
            .footer { margin-top: 50px; font-size: 12px; text-align: center; color: #6c757d; border-top: 1px solid #e0e0e0; padding-top: 25px; }
          </style>
        </head>
        <body>
          <div class="header">
            
            <h2>KUSUR ORANI HESAPLAMA RAPORU</h2>
            <p>Tarih: ${currentDate}</p>
          </div>
          
          <div class="result-grid">
            <div class="result-box">
              <h3>SİZİN DURUMUNUZ</h3>
              <div class="rate">${kayit.bizOran}</div>
              <div class="status">${kayit.bizDurum}</div>
            </div>
            <div class="result-box">
              <h3>KARŞI TARAF</h3>
              <div class="rate">${kayit.karsiOran}</div>
              <div class="status">${kayit.karsiDurum}</div>
            </div>
          </div>

          <div class="footer">
            <p>Bu rapor bilgi amaçlıdır. Yasal işlemlerde kullanmadan önce bir uzmana danışınız.</p>
            <p>© ${new Date().getFullYear()} ARS Hukuk</p>
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    setTimeout(() => printWindow.print(), 300);
  };

  return (
    <>
      <Helmet>
        <title>KUSUR ORANI HESAPLAMA | ARS HUKUK</title>
        <meta
          name="description"
          content="Trafik kazası kusur oranı hesaplama - ARS HUKUK"
        />
      </Helmet>

      <WhiteNavbar navbarSelection={"kusur-orani-hesaplama"} />
      <br /><br /><br /><br />

      <Container style={{ fontFamily: "Nucleo Outline" }}>
        <div>
          <br />
          <h2
            className="ml-auto mr-auto text-center"
            style={{ color: "#123274", fontFamily: "Benguiat Regular" }}
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <b>KUSUR ORANI HESAPLAMA</b>
          </h2>
          <p
            className="text-center"
            style={{ maxWidth: "700px", margin: "16px auto 0" }}
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            Kaza tespit tutanağına göre tahmini kusur oranını hesaplayın
          </p>
          <br />
        </div>

        {/* Form Card */}
        <div
          className="card"
          style={{
            borderRadius: "12px",
            border: "none",
            overflow: "hidden",
            boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
            marginBottom: "24px",
          }}
          data-aos="zoom-in"
          data-aos-duration="1000"
        >
          <div
            style={{
              background: "#123274",
              padding: "16px 24px",
              color: "white",
            }}
          >
            <h4
              style={{
                color: "white",
                fontSize: "1.2rem",
                fontWeight: 600,
                margin: 0,
                display: "flex",
                alignItems: "center",
              }}
            >
              <FaGavel style={{ marginRight: "12px", opacity: 0.9 }} />
              KUSUR MADDELERİ SEÇİMİ
            </h4>
          </div>
          <div style={{ padding: "32px" }}>
            <Alert color="info" className="mb-4">
              <FaInfoCircle className="me-2" />
              Lütfen kaza tutanağında yer alan ihlal maddelerini seçiniz.
            </Alert>

            <form onSubmit={handleSubmit}>
              <Row className="g-3 g-md-4">
                <Col md={6}>
                  <label
                    style={{
                      fontWeight: 600,
                      marginBottom: "6px",
                      fontSize: "0.95rem",
                      color: "#344767",
                    }}
                  >
                    Sizin İhlaliniz: <span style={{ color: "red" }}>*</span>
                  </label>
                  <InputGroup>
                    <Input
                      type="select"
                      name="biz"
                      value={formData.biz}
                      onChange={handleChange}
                      required
                      style={{
                        padding: "1rem 1.25rem",
                        borderColor: "#e9ecef",
                        fontSize: "1rem",
                        borderRadius: "9999px",
                      }}
                    >
                      <option value="">Lütfen Madde Seçin</option>
                      {trafficCodes.map((code, index) => (
                        <option key={index} value={code.label}>
                          {code.label}
                        </option>
                      ))}
                    </Input>
                  </InputGroup>
                  <small style={{ color: "#6c757d", marginTop: "8px", display: "block" }}>
                    Kendi aracınız için belirlenen ihlal maddesi
                  </small>
                </Col>

                <Col md={6}>
                  <label
                    style={{
                      fontWeight: 600,
                      marginBottom: "6px",
                      fontSize: "0.95rem",
                      color: "#344767",
                    }}
                  >
                    Karşı Tarafın İhlali: <span style={{ color: "red" }}>*</span>
                  </label>
                  <InputGroup>
                    <Input
                      type="select"
                      name="karsi"
                      value={formData.karsi}
                      onChange={handleChange}
                      required
                      style={{
                        padding: "1rem 1.25rem",
                        borderColor: "#e9ecef",
                        fontSize: "1rem",
                        borderRadius: "9999px",
                      }}
                    >
                      <option value="">Lütfen Madde Seçin</option>
                      {trafficCodes.map((code, index) => (
                        <option key={`karsi-${index}`} value={code.label}>
                          {code.label}
                        </option>
                      ))}
                    </Input>
                  </InputGroup>
                  <small style={{ color: "#6c757d", marginTop: "8px", display: "block" }}>
                    Karşı araç sürücüsü için belirlenen ihlal maddesi
                  </small>
                </Col>
              </Row>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                  marginTop: "32px",
                  gap: "16px",
                }}
              >
                <Button
                  type="button"
                  onClick={handleClearForm}
                  size="lg"
                  style={{
                    backgroundColor: "white",
                    borderColor: "#6c757d",
                    color: "#6c757d",
                    padding: ".75rem 1.5rem",
                    fontWeight: 600,
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                  className="shadow-sm"
                >
                  <FaTrash /> Formu Temizle
                </Button>

                <Button
                  type="submit"
                  size="lg"
                  disabled={loading}
                  style={{
                    backgroundColor: "#123274",
                    borderColor: "#123274",
                    padding: ".75rem 2rem",
                    fontWeight: 600,
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                  className="shadow"
                >
                  {loading ? (
                    <>
                      <Spinner size="sm" /> Hesaplanıyor...
                    </>
                  ) : (
                    <>
                      <FaExclamationTriangle className="me-2" /> Oranı Hesapla
                    </>
                  )}
                </Button>
              </div>
            </form>
          </div>
        </div>

        {/* Results */}
        <div id="sonuc-container">
          {uiSonuc && (
            <Card
              style={{
                borderRadius: "12px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                border: "none",
                overflow: "hidden",
                backgroundColor: "white",
                marginBottom: "24px",
              }}
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <CardBody className="p-0">{uiSonuc}</CardBody>
            </Card>
          )}
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default KusurOraniHesaplama;